import axios from "axios";

const Instance = axios.create({
  baseURL: "https://eqcas-backend-eske.onrender.com/api/v1/",
});

export default Instance;